import { type JSX } from 'react';
import { matchPath } from 'react-router-dom';

import { SidebarItemsType, isSidebarLink } from '../../types/sidebar';
import SidebarNavLinkItem from './SidebarNavLinkItem';
import SidebarNavActionItem from './SidebarNavActionItem';
import SidebarNavList from './SidebarNavList';

type ReduceChildRoutesProps = {
  depth: number;
  page: SidebarItemsType;
  items: JSX.Element[];
  currentRoute: string;
};

const reduceChildRoutes = (props: ReduceChildRoutesProps) => {
  const { items, page, depth, currentRoute } = props;

  if (!isSidebarLink(page)) return items;

  if ('href' in page) {
    const { href, title } = page;
    if (page.children?.length) {
      const open = !!matchPath({ path: href, end: false }, currentRoute);
      items.push(
        <SidebarNavLinkItem depth={depth} icon={page.icon} key={title} badge={page.badge} open={open} title={title} href={href}>
          <SidebarNavList depth={depth + 1} pages={page.children} key={title} />
        </SidebarNavLinkItem>
      );
    } else {
      items.push(
        <SidebarNavLinkItem
          depth={depth}
          href={href}
          target={page.target}
          eventCode={page.eventCode}
          icon={page.icon}
          key={title}
          badge={page.badge}
          title={title}
        />
      );
    }
  } else {
    items.push(
      <SidebarNavActionItem
        depth={depth}
        onAction={page.onAction}
        icon={page.icon}
        key={page.title}
        title={page.title}
        eventCode={page.eventCode}
      />
    );
  }

  return items;
};

export default reduceChildRoutes;
